<template>
  <div class="swiperContainer" style="">
    <swiper
      :options="swiperOption"
      ref="mySwiper"
      style="width: 830px; overflow: hidden; margin: 0 auto"
    >
      <swiper-slide
        class="swiper-slide swiper-container-3d swiperSlide"
        v-for="(img, index) in imgList"
        :key="index"
      >
        <img class="swiperImg" :src="img.imgUrl" />
        <span class="mask cp" @click="goCourseDetails(img.catId)">
          <div class="maskTag">
            <img :src="imagePath.lrList" alt="" />
            <span>共{{ img.slidesAmount }}</span>
          </div>
          <span>{{ img.catName }}</span>
        </span>
      </swiper-slide>

      <!-- 分页器 -->

      <div class="swiper-pagination" slot="pagination" style=""></div>
      <!-- 左右箭头 -->
      <!-- @click="prev" -->
      <div class="swiper-button-prev" slot="button-prev">
        <img :src="imagePath.leftBtn" alt="" />
      </div>
      <!-- @click="next" -->
      <div class="swiper-button-next" slot="button-next">
        <img :src="imagePath.rightBtn" alt="" />
      </div>
    </swiper>
  </div>
</template>

<script>
import imagePath from "@/utils/imagePath";
import { getColorByClassLevelId } from "@/utils/getColor.js";

export default {
  name: "MySwiper",
  components: {},
  props: {
    imgList: {
      type: Array,
      default: () => []
    },
    classLevelId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      imagePath,
      swiperOption: {
        loop: false, // 是否循环轮播
        speed: 1000, // 切换速度
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        // 自动轮播
        // autoplay: {
        //   delay: 2000,
        //   disableOnInteraction: false,
        // },
        // 设置slider容器能够同时显示的slides数量
        slidesPerView: 3,
        // 左右切换
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        // 分页器
        pagination: {
          el: ".swiper-pagination",
          clickable: true // 允许点击小圆点跳转
        }
        // 设置轮播样式,此处为3d轮播效果
        // effect: "coverflow",
        // coverflowEffect: {
        //   rotate: 30, // 旋转的角度
        //   stretch: 10, // 拉伸 图片间左右的间距和密集度
        //   depth: 60, // 深度 切换图片间上下的间距和密集度
        //   modifier: 2, // 修正值 该值越大前面的效果越明显
        //   slideShadows: true, // 页面阴影效果
        // },
      }
    };
  },
  mounted() {
    // 改变轮播图分页样式 根据classLevelId存的数据而变化
    const color1 = getColorByClassLevelId(
      (this.classLevelId * 1 - 1).toString()
    );
    const swiperPage1 = document.getElementsByClassName(
      "swiper-pagination-bullet"
    );
    if (!color1) return;
    if (swiperPage1.length > 0) {
      for (let i = 0; i < swiperPage1.length; i++) {
        swiperPage1[i].style.background = color1.selected;
      }
    }
    const color2 = getColorByClassLevelId(this.classLevelId);
    if (!color2) return;
    // console.log(color2, "color2");
    const swiperPage2 = document.getElementsByClassName(
      "swiper-pagination-bullet"
    );
    if (swiperPage2.length > 0) {
      for (let i = 0; i < swiperPage2.length; i++) {
        swiperPage2[i].style.background = color2.selected;
      }
    }
  },
  updated() {
    if ((this.classLevelId * 1) % 2 === 0) {
      // 改变轮播图分页样式 根据classLevelId存的数据而变化
      const color1 = getColorByClassLevelId(this.classLevelId);
      if (!color1) return;
      const swiperPage1 = document.getElementsByClassName(
        "swiper-pagination-bullet"
      );
      if (swiperPage1.length > 0) {
        for (let i = 0; i < swiperPage1.length; i++) {
          swiperPage1[i].style.background = color1.selected;
        }
      }
      const color2 = getColorByClassLevelId(
        (this.classLevelId * 1 + 1).toString()
      );
      if (!color2) return;
      // console.log(color2, "color2");
      const swiperPage2 = document
        .getElementsByClassName("swiper-pagination-clickable")[1]
        .getElementsByClassName("swiper-pagination-bullet");
      if (swiperPage2.length > 0) {
        for (let i = 0; i < swiperPage2.length; i++) {
          swiperPage2[i].style.background = color2.selected;
        }
      }
      // console.log(this.classLevelId, "classLevelId", color, "color");
    }
  },
  methods: {
    // 跳转到课程详情
    goCourseDetails(id) {
      // console.log(id, "id");
      this.$emit("goCourseDetails", id);
    }
  }
};
</script>
<style lang="less" scoped>
.swiper-button-prev,
.swiper-button-next {
  img {
    width: 25px;
    height: 102px;
  }
}

.swiper-button-prev {
  left: 0px;
}

.swiper-button-next {
  right: 0px;
}

.swiper-button-prev:after,
.swiper-button-next:after {
  content: "";
}

.swiper-pagination {
  width: 830px;
  height: 70px;
  line-height: 70px;
}

/deep/ .swiper-pagination-clickable .swiper-pagination-bullet {
  width: 40px;
  height: 6px;
  background: #ff7a49;
  border-radius: 8px;
}

.swiper-slide:hover {
  .mask {
    display: flex;
    box-shadow: 0px 0px 2px #999;
  }
}

.mask {
  display: none;
  position: absolute;
  // display: flex;
  justify-content: center;
  align-items: center;
  left: 3.3px;
  z-index: 999;
  width: 270px;
  height: 150px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 20px;

  > span {
    padding: 0 14px;
    min-width: 100px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 25px;
    font-size: 18px;
    color: #333333;
    font-weight: 550;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .maskTag {
    position: absolute;
    top: 24px;
    left: -6px;

    img {
      width: 51px;
      height: 29px;
    }

    span {
      position: absolute;
      left: 0;
      width: 51px;
      height: 23px;
      line-height: 23px;
      text-align: center;
    }
  }
}

.swiperContainer {
  width: 900px;
  height: 150px;
  position: relative;

  .swiperSlide {
    position: relative;
    overflow: hidden;
    width: 810px;
    height: 150px;

    .swiperImg {
      position: absolute;
      top: 0;
      left: 50%;
      width: 270px;
      height: 150px;
      transform: translate(-50%, 0);
      border-radius: 20px;
      object-fit: cover;
    }
  }
}

/deep/ .swiper-container {
  width: 830px !important;
  height: 150px !important;
}
</style>
